module.exports = __webpack_public_path__ + "img/image_certification.b8823a71.png";